export enum AssetType {
  Balance = 'balance',
  InsuranceDeposit = 'insurance_deposit',
  External = 'external',
}
